let sliderInitializers = [];
let geoBannerObserver = null;

function isGeoMangoBannerVisible() {
  if (typeof window.KisaanSayIsGeoMangoBannerVisible === 'function') {
    return window.KisaanSayIsGeoMangoBannerVisible();
  }

  const geoHero = document.querySelector('.custom-slideshow[data-geo-hero="true"]');
  if (!geoHero) return false;

  const locationState = geoHero.getAttribute('data-geo-location');
  if (locationState === 'allowed') return true;
  if (locationState === 'denied') return false;

  if (geoHero.querySelector('.geo-hero-slide')) return true;

  const decision = geoHero.getAttribute('data-geo-decision');
  return !!(decision && decision !== 'default');
}

function syncGirKesarFromBanner() {
  const show = isGeoMangoBannerVisible();

  document.querySelectorAll('[data-geo-gated-product]').forEach((card) => {
    card.hidden = !show;
    card.classList.toggle('is-geo-visible', show);
  });

  sliderInitializers.forEach((initializeSlider) => {
    if (typeof initializeSlider === 'function') initializeSlider();
  });
}

function scheduleGeoGatedProductSync() {
  syncGirKesarFromBanner();
  [100, 300, 600, 1200, 2500].forEach((delay) => {
    window.setTimeout(syncGirKesarFromBanner, delay);
  });
}

function watchGeoBannerTrack() {
  if (geoBannerObserver) return;

  const geoHero = document.querySelector('.custom-slideshow[data-geo-hero="true"]');
  if (!geoHero) return;

  geoBannerObserver = new MutationObserver(() => {
    syncGirKesarFromBanner();
  });

  geoBannerObserver.observe(geoHero, {
    attributes: true,
    attributeFilter: ['data-geo-decision', 'data-geo-resolved', 'data-geo-location'],
    subtree: true,
    childList: true,
  });
}

(function wrapGeoSync() {
  const geoSync = window.KisaanSaySyncGeoGatedProducts;
  window.KisaanSaySyncGeoGatedProducts = function () {
    if (typeof geoSync === 'function') geoSync();
    else syncGirKesarFromBanner();
    sliderInitializers.forEach((initializeSlider) => {
      if (typeof initializeSlider === 'function') initializeSlider();
    });
  };
})();

document.addEventListener('geo-hero:banner-sync', scheduleGeoGatedProductSync);
document.addEventListener('geo-hero:reinit-carousel', scheduleGeoGatedProductSync);
document.addEventListener('geo-hero:ready', scheduleGeoGatedProductSync);
window.addEventListener('pageshow', scheduleGeoGatedProductSync);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    watchGeoBannerTrack();
    scheduleGeoGatedProductSync();
  });
} else {
  watchGeoBannerTrack();
  scheduleGeoGatedProductSync();
}

document.addEventListener('DOMContentLoaded', function() {

  /*** ===== Mobile Slider ===== ***/
  function initMobileSlider(container) {
    const slider = container.querySelector('[data-mobile-slider]');
    const cards = container.querySelectorAll('.mobile-slider-card:not([hidden])');
    const prevBtn = container.querySelector('.slider-arrow-left');
    const nextBtn = container.querySelector('.slider-arrow-right');

    if (!slider || cards.length === 0) return;

    let scrollTimeout;

    function getCardScrollPosition(index) {
      return cards[index].offsetLeft;
    }

    function getActiveIndex() {
      let activeIndex = 0;
      let minDistance = Infinity;

      cards.forEach((card, index) => {
        const distance = Math.abs(slider.scrollLeft - getCardScrollPosition(index));
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    function updateSliderState(activeIndex) {
      if (prevBtn) prevBtn.hidden = activeIndex <= 0;
      if (nextBtn) nextBtn.hidden = activeIndex >= cards.length - 1;
    }

    function scrollToIndex(index) {
      if (window.innerWidth > 768) return;

      const targetIndex = Math.max(0, Math.min(index, cards.length - 1));
      slider.scrollTo({
        left: getCardScrollPosition(targetIndex),
        behavior: 'smooth'
      });
      updateSliderState(targetIndex);
    }

    function initializeSlider() {
      if (window.innerWidth > 768) return;
      updateSliderState(getActiveIndex());
    }

    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        updateSliderState(getActiveIndex());
      }, 50);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => scrollToIndex(getActiveIndex() - 1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => scrollToIndex(getActiveIndex() + 1));
    }

    initializeSlider();
    return initializeSlider;
  }

  sliderInitializers = [];
  document.querySelectorAll('.mobile-slider-container').forEach((container) => {
    sliderInitializers.push(initMobileSlider(container));
  });

  watchGeoBannerTrack();
  scheduleGeoGatedProductSync();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      sliderInitializers.forEach((initializeSlider) => {
        if (typeof initializeSlider === 'function') initializeSlider();
      });
    }, 250);
  });

  /*** ===== Product Variant Updates ===== ***/
  function updateProductInfo(productId, selectedOption) {
    const variantId = selectedOption.value;
    const price = parseInt(selectedOption.dataset.price);
    const comparePrice = selectedOption.dataset.comparePrice ? parseInt(selectedOption.dataset.comparePrice) : 0;
    const available = selectedOption.dataset.available === 'true';

    const productCards = document.querySelectorAll(`[data-product-id="${productId}"]`);

    productCards.forEach(card => {
      const priceEl = card.querySelector('.current-price');
      if (priceEl) {
        priceEl.textContent = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(price / 100);
        priceEl.setAttribute('data-price', price);
      }

      const originalPriceEl = card.querySelector('.original-price');
      const discountBadgeEl = card.querySelector('.discount-badge');

      if (comparePrice && comparePrice > price) {
        if (originalPriceEl) {
          originalPriceEl.textContent = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(comparePrice / 100);
          originalPriceEl.style.display = 'inline';
        }

        if (discountBadgeEl) {
          discountBadgeEl.textContent = `${Math.round(((comparePrice - price) / comparePrice) * 100)}% OFF`;
          discountBadgeEl.style.display = 'inline';
        }
      } else {
        if (originalPriceEl) originalPriceEl.style.display = 'none';
        if (discountBadgeEl) discountBadgeEl.style.display = 'none';
      }

      const hiddenInput = card.querySelector('.product-variant-id');
      if (hiddenInput) hiddenInput.value = variantId;

      const button = card.querySelector('.bestseller-add-to-cart');
      const buttonText = button?.querySelector('span');

      if (button && buttonText) {
        if (available) {
          button.disabled = false;
          button.removeAttribute('disabled');
          buttonText.textContent = button.closest('form')?.dataset.addToCartText || 'Add to Cart';
        } else {
          button.disabled = true;
          button.setAttribute('disabled', 'disabled');
          buttonText.textContent = 'Sold out';
        }
      }
    });
  }

  document.querySelectorAll('.variant-dropdown').forEach(select => {
    select.addEventListener('change', function() {
      const productId = this.dataset.productId;
      const selectedOption = this.options[this.selectedIndex];

      updateProductInfo(productId, selectedOption);

      document.querySelectorAll(`[data-product-id="${productId}"] .variant-dropdown`).forEach(otherSelect => {
        if (otherSelect !== this) otherSelect.value = this.value;
      });
      document.dispatchEvent(
        new CustomEvent('product-card:variant-change', {
          bubbles: true,
          detail: { productId: productId, variantId: selectedOption.value },
        })
      );
    });
  });

  document.querySelectorAll('.bestseller-add-to-cart').forEach(button => {
    const form = button.closest('form');
    if (form) {
      const buttonText = button.querySelector('span');
      if (buttonText) form.dataset.addToCartText = buttonText.textContent.trim();
    }
  });

});
